import script from "./FormSubmitted.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSubmitted.vue?vue&type=script&setup=true&lang=js"

import "./FormSubmitted.vue?vue&type=style&index=0&id=111afd36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111afd36"]])

export default __exports__